<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import ErrorPage from "@/components/ErrorPage.vue";

// 权限不足时由 router.beforeEach 重定向过来（带 ?target= 记录原本想去的地址）。
// 用警告色与 404 区分开：一个是「没权限」，一个是「不存在」。
const route = useRoute();
const path = computed(() => (route.query.target as string) || route.fullPath);
</script>

<template>
  <ErrorPage
    code="403"
    title="没有访问权限"
    description="当前账号没有查看该页面的权限，请更换访问目标，或登录后再试。"
    :path="path"
    tone="warning"
  />
</template>
